import React from 'react'
import classNames from 'classnames'
import { Text } from 'components/Text'
import { TitleProps } from '.'

export function Title({
  children,
  className = 'margin-bottom-32',
}: TitleProps) {
  return (
    <Text.Title
      className={classNames('transition', className)}
      data-test-id="title"
    >
      {children}
    </Text.Title>
  )
}
